import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/backorders`, {
        params: {
            ...params
        },
    });
};

const BackorderService = {
    List,
};

export default BackorderService;
